<app-header role="heading" id="header"></app-header>
<div id="app" class="container">
  <div class="row mx-1 mt-4">
    <main role="main" id="main" class="col">
        <router-outlet></router-outlet>
    </main>
  </div>
</div>
<app-footer id="footer"></app-footer>
